import { useContext, useState } from 'react';
import { AbbottLogo } from '@abbott-components/core';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import {
  WorkflowEngineActionKind,
  WorkflowEngineContext,
  WorkflowEngineMode
} from './workflowEngineReducer';
import isBuilding from '../Shared/jsonSchemaUtilities/isBuilding';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import UnsavedChangesWarningDialog from './UnsavedChangesWarningDialog';
import { Box } from '@mui/system';

export default () => {
  const { state, dispatch } = useContext(WorkflowEngineContext);
  const { mode, pages, isReadOnlyView } = state;

  const [openUnsavedChangesWarningDialog, setOpenUnsavedChangesWarningDialog] =
    useState(false);
  const [selectedTab, setselectedTab] = useState(WorkflowEngineMode.BUILD);

  const handleCloseDialog = () => {
    setOpenUnsavedChangesWarningDialog(false);
  };

  const handleChange = (
    event: React.SyntheticEvent,
    newValue: WorkflowEngineMode
  ) => {
    if (isBuilding(pages) && !isReadOnlyView) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (
      mode === WorkflowEngineMode.MAPPER &&
      window.GrapeCity?.ActiveReports.WebDesigner.api.isReportDirty()
    ) {
      setselectedTab(newValue);
      setOpenUnsavedChangesWarningDialog(true);
      return;
    }

    handleTabChange(newValue);
  };

  const handleTabChange = (tab: WorkflowEngineMode) => {
    switch (tab) {
      case WorkflowEngineMode.BUILD:
        dispatch({ type: WorkflowEngineActionKind.SET_BUILD_MODE });
        break;
      case WorkflowEngineMode.PREVIEW:
        dispatch({ type: WorkflowEngineActionKind.SET_PREVIEW_MODE });
        break;
      case WorkflowEngineMode.MAPPER:
        dispatch({ type: WorkflowEngineActionKind.SET_MAPPER_MODE });
        break;
      default:
        break;
    }
  };

  return (
    <>
      <AppBar position="absolute" elevation={1}>
        <Toolbar>
          <Typography
            sx={{
              flexGrow: 1,
              padding: '0.4rem',
              height: '4rem'
            }}
            component={Box}
          >
            <div
              style={{
                minWidth: '100px',
                maxWidth: '200px',
                padding: '0.8rem',
                height: '3rem'
              }}
            >
              <AbbottLogo color="white" />
            </div>
          </Typography>
          <Tabs
            value={mode}
            onChange={handleChange}
            textColor="inherit"
            indicatorColor="secondary"
          >
            <Tab value={WorkflowEngineMode.BUILD} label="Workflow" />
            <Tab value={WorkflowEngineMode.MAPPER} label="Form" />
            <Tab value={WorkflowEngineMode.PREVIEW} label="Preview" />
          </Tabs>
        </Toolbar>
      </AppBar>
      <UnsavedChangesWarningDialog
        open={openUnsavedChangesWarningDialog}
        selectedTab={selectedTab}
        handleClose={handleCloseDialog}
        handleOk={handleTabChange}
      />
    </>
  );
};
